import { STATUS } from '@Utils/constants';
import { SensorPeekAsyncResponse, TroubleshootingRequests } from './peek';

export interface SensorDataPoint {
	value: SensorDataValue;
	timestamp: SensorDataTimestamp;
	newValue?: number;
}

export interface EditSensorDataSort {
	name: 'dataEditor-dateTime' | 'dataEditor-curValue';
	order: 'asc' | 'desc';
}

export interface SensorDataValue {
	doubleValue: number;
	unit: string;
}

export interface SensorDataTimestamp {
	timeInSeconds: number;
	timestamp: string;
}

export enum STATUS_ENUM {
	IDLE = 'idle',
	PENDING = 'pending',
	SUCCESS = 'success',
	ERROR = 'error',
}

export interface GetSensorHistoryParams {
	sensorId: string;
	limit: number;
	offset: number;
	startDate: Date;
	endDate: Date;
	order: 'DESC' | 'ASC';
}

export interface GetSensorHistoryResponse {
	sensorById: string;
	history: SensorDataPoint[];
}
interface PeekState {
	status: STATUS;
	statusTblt: STATUS;
	query: string;
	queryComputing: STATUS;
	response: {
		data: { ts: string; value: number | string }[];
		fields: Record<string, { status: string; errorMsg: string }>;
	};
	responseAsync: SensorPeekAsyncResponse;
	troubleshooting: Partial<TroubleshootingRequests>;
}
export interface SensorHistoryStoreState {
	sensorById?: string;
	history: SensorDataPoint[];
	sensorDataOverride: [number, number][];
	initialized?: boolean;
	reload?: boolean;
	status: STATUS;
	peek: PeekState;
}

export interface NewSensorDataPointsParams {
	newValue: number;
	oldValue: number;
	timeStamp: string;
	sensorId: string;
}
